module.exports = __webpack_public_path__ + "static/media/trans_nod_logo.31dec74e.png";